class ReferAFriend extends HTMLElement {
  constructor() {
    super();
    this.customerFirstName = this.dataset.customerFirstName;
    this.customerLastName = this.dataset.customerLastName;
    this.customerEmail = this.dataset.customerEmail;
    this.customerId = this.dataset.customerId;
    this.mentionMeUrl = 'https://tag.mention-me.com/api/v2';
  }

  connectedCallback() {    
    this.loadMentionMeScript('referreroffer', '', { situation: 'landingpage' }, true);
  }

  loadMentionMeScript(subject, endpoint, args, addCustomer) {
    if (addCustomer) {
      args = Object.assign(
        {},
        {
          firstname: this.customerFirstName || '',
          surname: this.customerLastName || '',
          email: this.customerEmail || '',
          customer_id: this.customerId || '',
        },
        args
      );
    }

    const urlArgs = new URLSearchParams(args);
    const mmRefereeTag = document.createElement('script');
    mmRefereeTag.src = `${this.mentionMeUrl}/${subject}/mm501fef7e${endpoint}?locale=en_GB&${urlArgs}`;
    document.body.appendChild(mmRefereeTag);
  }
}

if (!customElements.get('refer-a-friend')) {
  customElements.define('refer-a-friend', ReferAFriend);
}
